export const EXPAND_BLOCK = 'EXPAND_BLOCK';
export const COLLAPSE_BLOCK = 'COLLAPSE_BLOCK';

export type ExpandBlockResult = {
    type: string;
    payload: {
        containerName: string;
        blockName: string;
    };
}

export type CollapseBlockResult = {
    type: string;
    payload: {
        containerName: string;
        blockName: string;
    };
}

/**
 * Block has expanded.
 *
 * @param {string} containerName
 * @param {string} blockName
 * @returns {ExpandBlockResult}
 */
export const expandBlock = (containerName: string, blockName: string): ExpandBlockResult => {
    return {type: EXPAND_BLOCK, payload: {containerName, blockName}};
};

/**
 * Block has collapsed.
 *
 * @param {string} containerName
 * @param {string} blockName
 * @returns {CollapseBlockResult}
 */
export const collapseBlock = (containerName: string, blockName: string): CollapseBlockResult => {
    return {type: COLLAPSE_BLOCK, payload: {containerName, blockName}};
};